import { render, staticRenderFns } from "./deviceGauge.vue?vue&type=template&id=7f845d4b&"
import script from "./deviceGauge.vue?vue&type=script&lang=js&"
export * from "./deviceGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f845d4b')) {
      api.createRecord('7f845d4b', component.options)
    } else {
      api.reload('7f845d4b', component.options)
    }
    module.hot.accept("./deviceGauge.vue?vue&type=template&id=7f845d4b&", function () {
      api.rerender('7f845d4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/zhlg/components/deviceGauge.vue"
export default component.exports